import Vue from 'vue'
import VueRouter from 'vue-router'
import Authentication from '@/components/pages/Authentication/Authentication'
import * as Auth from '@/components/pages/Authentication'
import Home from '@/components/pages/Home'
import Documents from '@/components/pages/Documents'
import Debtors from '@/components/pages/Debtors'
import Contacts from '@/components/pages/Contacts'
import About from '@/components/pages/About'
import Requisites from '@/components/pages/Requisites'

import GoBankrupt from '@/components/pages/Debtors/GoBankrupt'
import CancelCourtOrder from '@/components/pages/Debtors/CancelCourtOrder'
import ForgetDebt from '@/components/pages/Debtors/ForgetDebt'
import StopDebtor from '@/components/pages/Debtors/StopDebtor'
import Pay from '@/components/pages/Debtors/Pay'
import DiscountRepayment from '@/components/pages/Debtors/DiscountRepayment'
import CertificateDebt from '@/components/pages/Debtors/CertificateDebt'
import ApplyPlan from '@/components/pages/Debtors/ApplyPlan'
import SVODebt from '@/components/pages/Debtors/SVO'


import Users from '@/components/pages/Admin/Users'
import AdminDocuments from '@/components/pages/Admin/Documents'
import AdminContacts from '@/components/pages/Admin/Contacts'
import AdminAbout from '@/components/pages/Admin/About'
import AdminRequisites from '@/components/pages/Admin/Requisites'
import AdminDiscountRepayment from '@/components/pages/Admin/DiscountRepayment'
import AdminCertificateDebt from '@/components/pages/Admin/CertificateDebt'
import AdminApplyPlan from '@/components/pages/Admin/ApplyPlan'
import AdminGoBankrupt from '@/components/pages/Admin/GoBankrupt'
import AdminCancelCourtOrder from '@/components/pages/Admin/CancelCourtOrder'
import AdminForgetDebt from '@/components/pages/Admin/ForgetDebt'
import AdminStopDebtor from '@/components/pages/Admin/StopDebtor'
import AdminPay from '@/components/pages/Admin/Pay'
import AdminSVO from '@/components/pages/Admin/SVO'
import AdminSettings from '@/components/pages/Admin/Settings'




Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Главная',
        components: {
            default: Home
        },
        meta: {
            header: 'default',
        }
    },
    {
        path: '/documents',
        name: 'Документы',
        components: {
            default: Documents
        },
        meta: {
            header: 'default',
            showmenu: true,
        },
    },
    {
        path: '/debtors',
        name: 'Должникам',        
        components: {
            default: Debtors
        },
        meta: {
            header: 'default',
            showmenu: true,
        },
        children: [
            {
                path: 'bunkrupt',
                name: 'Стать банкротом',
                components: {
                    default: GoBankrupt
                },
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'cancel',
                name: 'Отменить судебный приказ',
                component: CancelCourtOrder,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'forget',
                name: 'Забыть про свой долг',
                component: ForgetDebt,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'stop',
                name: 'Перестать быть должником',
                component: StopDebtor,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'pay',
                name: 'Оплатить при помощи СБП',
                component: Pay,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'discount',
                name: 'Погашение со скидкой',
                component: DiscountRepayment,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'certificate',
                name: 'Справка об отсутствии задолженности',
                component: CertificateDebt,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'apply',
                name: 'Обратиться за рассрочкой',                
                component: ApplyPlan,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
            {
                path: 'svo',
                name: 'Участникам СВО - списание долга',                
                component: SVODebt,
                meta: {
                    header: 'default',
                    showmenu:true
                }
            },
        ]
    },
    {
        path: '/contacts',
        name: 'Контакты',        
        components: {
            default: Contacts
        },
        meta: {
            header: 'default',
            showmenu: true,
        }
    },
    {
        path: '/about',
        name: 'О компании',        
        components: {
            default: About
        },
        meta: {
            header: 'default',
            showmenu: true,
        }
    },
    {
        path: '/requisites',
        name: 'Реквизиты',        
        components: {
            default: Requisites
        },
        meta: {
            header: 'default',
            showmenu: true,
        }
    },
    {
        path: '/admin/users',
        name: 'Пользователи',
        header: 'admin',        
        components: {
            default: Users
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/documents',
        name: 'Документы ',
        components: {
            default: AdminDocuments
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        },
    },
    {
        path: '/admin/contacts',
        name: 'Контакты ',        
        components: {
            default: AdminContacts
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/about',
        name: 'О компании ',        
        components: {
            default: AdminAbout
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/requisites',
        name: 'Реквизиты ',        
        components: {
            default: AdminRequisites
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },    
    {
        path: '/admin/discount',
        name: 'Погашение со скидкой ',
        header: 'admin',        
        components: {
            default: AdminDiscountRepayment
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/certificate',
        name: 'Справка об отсутствии задолженности ',
        header: 'admin',        
        components: {
            default: AdminCertificateDebt
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/apply',
        name: 'Обратиться за рассрочкой ',
        header: 'admin',        
        components: {
            default: AdminApplyPlan
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/bunkrupt',
        name: 'Стать бакротом ',
        header: 'admin',        
        components: {
            default: AdminGoBankrupt
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/cancel',
        name: 'Отменить судебный приказ ',
        header: 'admin',        
        components: {
            default: AdminCancelCourtOrder
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/forget',
        name: 'Забыть про свой долг ',
        header: 'admin',        
        components: {
            default: AdminForgetDebt
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/stop',
        name: 'Перестать быть должником ',
        header: 'admin',        
        components: {
            default: AdminStopDebtor
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/pay',
        name: 'Оплатить при помощи СБП ',
        header: 'admin',        
        components: {
            default: AdminPay
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/svo',
        name: 'Участникам СВО - списание долга',
        header: 'admin',        
        components: {
            default: AdminSVO
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin/settings',
        name: 'Настройки',
        header: 'admin',        
        components: {
            default: AdminSettings
        },
        meta: {
            requiredAuth: true,
            header: 'admin',
            showmenu: true,
            admin: true
        }
    },
    {
        path: '/admin',
        name: 'Authentication',
        component: Authentication,
        meta: {
            admin: true
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})
//перед переходом проверка на необходимость авторизации
router.beforeEach((to, from, next) => {
    if (to.meta.requiredAuth) {
        if (Auth.default.user.authenticated) {
            next()
        } else {
            router.push('/admin')
        }
    } else {
        next()
    }
})


export default router
